import { Suspense, lazy } from 'react'

/**
 * 开发期调试面板(Router + Query)。
 * 仅在 import.meta.env.DEV 下渲染;走 lazy 动态 import,生产构建里是独立 chunk 且永不加载。
 */
const LazyDevtools = lazy(async () => {
  const [{ TanStackRouterDevtools }, { ReactQueryDevtools }] = await Promise.all([
    import('@tanstack/react-router-devtools'),
    import('@tanstack/react-query-devtools'),
  ])
  return {
    default: function Devtools() {
      // 两个浮标都放右下:左下角是左导航的「收起」按钮,放那儿会互相挡住点击。
      return (
        <>
          <TanStackRouterDevtools position="bottom-right" />
          <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
        </>
      )
    },
  }
})

export function Devtools() {
  if (!import.meta.env.DEV) return null
  return (
    <Suspense fallback={null}>
      <LazyDevtools />
    </Suspense>
  )
}
